import facebook from './facebook';
import ltv from './ltv';
import twitch from './twitch';
import youtube from './youtube';

const requests = {
  facebook,
  ltv,
  twitch,
  youtube
};

export default requests;
